module.exports = __webpack_public_path__ + "img/face-hand-yawn.0fe7ab05.svg";